module.exports = __webpack_public_path__ + "static/media/Liberianlogo.b0edb135.png";